import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

const API_KEY = import.meta.env.VITE_APP_BUGSNAG_API_KEY ?? '';
const APP_STAGE = import.meta.env.VITE_APP_STAGE ?? 'unknown-stage';

// NOTE:
// 這個是測試框架自己加的，不必手動去加，
// 主要是避免 CI 跑測試也去初始化 Bugsnag 報 bug。
const IS_TEST = import.meta.env.TEST === 'true';

if (!IS_TEST) {
  Bugsnag.start({
    plugins: [new BugsnagPluginVue()],
    apiKey: API_KEY,
    releaseStage: APP_STAGE,
    // NOTE: 因為 SDK 嵌入在客戶網頁中，window.onerror 和 unhandledrejection 事件
    // 會捕捉整個頁面的錯誤（包括客戶自己的程式碼），因此關閉自動偵測。
    // 只透過 tre() 手動呼叫 Bugsnag.notify() 來回報我們 SDK 自身的錯誤。
    // https://docs.bugsnag.com/platforms/javascript/vue/configuration-options/#enablederrortypes
    // https://docs.bugsnag.com/platforms/javascript/vue/configuration-options/#autodetecterrors
    autoDetectErrors: false,
  });
}

export const tre = (err: any) => {
  // NOTE: 先 notify 再 console.error 比較好，因為 console.error 會佔一個 breadcrumb 而一個 notify 目前只會撿最後 25 個 breadcrumbs
  // REF: https://docs.bugsnag.com/platforms/javascript/configuration-options/#captured-errors
  // REF: https://docs.bugsnag.com/platforms/javascript/configuration-options/#maxbreadcrumbs
  Bugsnag.notify(err);
  console.error(err);
};

// NOTE: 官方用法目前就是用 static default instance
// 之後如果需要多 instance 再來調整
export default Bugsnag;
